import type { ButtonProps } from '@mui/material';
import { forwardRef } from 'react';

import {
  ButtonText,
  StyledButton,
} from './Button.styled.js';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledButton disableElevation disableRipple ref={ref} {...props}>
        <ButtonText>{children}</ButtonText>
      </StyledButton>
    );
  },
);

Button.displayName = 'Button';
